import React, { useState } from "react";
import "../styles.css";

const TeamSelectionModal = ({ isOpen, onClose, teams, onTeamSelect }) => {
  const [selectedTeamId, setSelectedTeamId] = useState(null);

  if (!isOpen) return null;

  const handleTeamSelect = () => {
    if (selectedTeamId) {
      onTeamSelect(selectedTeamId);
      onClose();
    }
  };

  return (
    <div className="modal">
      <div className="modal-content team-selection-modal">
        <h2 className="modal-title">Výběr týmu</h2>
        <p className="modal-subtitle">Vyberte tým, který bude odpovídat na otázku</p>
        
        <div className="team-selection-grid">
          {teams.map((team) => (
            <button
              key={team.id}
              className={`team-selection-card ${selectedTeamId === team.id ? 'selected' : ''}`}
              onClick={() => setSelectedTeamId(team.id)}
            >
              <h3 className="team-selection-name">{team.name}</h3>
              <div className="team-selection-score">{team.points} bodů</div>
            </button>
          ))}
        </div>

        <div className="modal-actions">
          <button 
            className="btn btn-cancel" 
            onClick={onClose}
          >
            Zrušit
          </button>
          <button 
            className="btn btn-confirm" 
            onClick={handleTeamSelect}
            disabled={!selectedTeamId}
          >
            Potvrdit výběr
          </button>
        </div>
        
        <button className="modal-close" onClick={onClose}>
          x
        </button>
      </div>
    </div>
  );
};

export default TeamSelectionModal;